module.exports = __webpack_public_path__ + "img/cloud-bottom-left-desktop.b80cfcf.webp";